export type Environment = 'octopus' | 'dev' | 'staging' | 'review' | 'post-prod' | 'production';

export enum TenantKeys {
  Default = 'default',
}

export const AUTH_APP_NAME = 'cafe_beca';
